export const QUERYPARAM_ACTIVE_ORG = "organization"
export const APPLOGIN = "applogin"
export const INITIAL_CREATE_HOME_NAME_QUERY_KEY = "home_name"
